module.exports = __webpack_public_path__ + "img/tarot-major-arcana-09.89e7c5a8.png";